import { render } from "./UploadingFileItem.vue?vue&type=template&id=3800c063&ts=true"
import script from "./UploadingFileItem.vue?vue&type=script&lang=ts"
export * from "./UploadingFileItem.vue?vue&type=script&lang=ts"

import "./UploadingFileItem.vue?vue&type=style&index=0&id=3800c063&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__